import React, { memo } from "react";
import * as PR from "../../../prime-modules/index";
import ChartDataLabels from "chartjs-plugin-datalabels";

const OrdersAndRevenueGraph = ({orderGraph, revenueGraph}) => {
  const ordersGraph = Array.isArray(orderGraph) ? orderGraph : [];
  const revenuesGraph = Array.isArray(revenueGraph) ? revenueGraph : [];
  const barThicknessValue = ordersGraph.length <= 4 ? 30 : 'flex';
  const labels = ordersGraph.map(value => {
    if (value?.xValue) {
      return value.xValue.split('-')[0];
    }
    return '';
  });
  const orderValues = ordersGraph ? ordersGraph?.map((value) => value.yValue) : [];
  const revenueValues = revenuesGraph ? revenuesGraph?.map((value) => value.yValue) : [];

  const formatDate = (dateString) => {
    const [day, month, year] = dateString.split('-');
    const date = new Date(`${year}-${month}-${day}`);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  const lineChartOptions = {
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false
    },
    stacked: false,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          color: "#495057",
          usePointStyle: true,
          padding: 20,
        },
      },
      datalabels: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function(tooltipItem) {
            const index = tooltipItem[0].dataIndex;
            const originalLabel = ordersGraph[index]?.xValue;
            if (originalLabel) {
              return formatDate(originalLabel);
            }
            return '';
          },
          label: function(tooltipItem) {
            const datasetLabel = tooltipItem.dataset.label || '';
            const value = tooltipItem.raw;
            return `${datasetLabel}: ${value}`;
          },
        },
      }
    },
    scales: {
      x: {
          type: "category",
          ticks: {
              color: '#000',
              callback: function(value, index, ticks) {
                return index > 0 && this.getLabelForValue(value) === this.getLabelForValue(ticks[index - 1].value)
                  ? ''
                  : this.getLabelForValue(value);
              }
          },
          grid: {
              color: '#e0e0e0',
              drawTicks: true,
              drawOnChartArea: false,
              lineWidth: function(ctx) {
                const index = ctx.index;
                const ticks = ctx.chart.data.labels;
                if (index === 0) return 1;

                return ticks[index] !== ticks[index - 1] ? 1 : 0; // Only draw if label is different from previous
              },
          }
      },
      y: {
          type: 'linear',
          display: true,
          position: 'left',
          title: {
            text: "Orders",
            display: true,
          },
          ticks: {
              color: '#000',
              precision: 0,
          },
          grid: {
              color: '#e0e0e0',
              drawOnChartArea: false,
          }
      },
      y1: {
          type: 'linear',
          display: true,
          position: 'right',
          title: {
            text: "Revenue",
            display: true,
          },
          ticks: {
              color: '#000',
              precision: 0,
          },
          grid: {
              drawOnChartArea: false,
              color: '#e0e0e0'
          }
      }
  }
  };

  const chartData = {
    labels: labels,
    datasets: [
      {
        type: 'bar',
        label: 'Orders',
        data: orderValues,
        borderColor: "#3e95cd",
        backgroundColor: "#003366",
        barThickness: barThicknessValue,
        maxBarThickness: 50,
        fill: true,
        tension: 0.4,
        pointBackgroundColor: "#3e95cd",
        yAxisID: 'y',
        order: 1
      },
      {
         type: 'line',
        label: 'Revenue',
        data: revenueValues,
        borderColor: "#F73859",
        backgroundColor: 'transparent', 
        fill: false,
        tension: 0,
        pointBackgroundColor: "#F73859",
        yAxisID: 'y1',
         order: 2
      },
    ],
  };

  return (
    <PR.Chart
      data={chartData}
      plugins={[ChartDataLabels]}
      options={lineChartOptions}
      style={{height:"360px"}}
    />
  );
};

export default memo(OrdersAndRevenueGraph);
